export enum StabilizationTypes {
  DrillHole = 'drillHole',
  PileHole = 'pileHole'
}